/* tslint:disable:only-arrow-functions*/
import { helpers } from 'vuelidate/lib/validators';

export const  greaterThenEqualAs = (gteTo) => {  
    return helpers.withParams({ type: 'greaterThenEqualAs', gteTo }, function(this: any, value, parentVm ) {
        return value >= helpers.ref(gteTo, this, parentVm);
    });
};

export const greaterThenEqualAsIf = (gteTo, ifCond) => {  
    return helpers.withParams({ type: 'greaterThenEqualAs', gteTo, ifCond }, function(this: any, value, parentVm ) {
        if(helpers.ref(ifCond, this, parentVm)) {
            return value >= helpers.ref(gteTo, this, parentVm);
        } else {
            return true;
        }
    });
};